module.exports = __webpack_public_path__ + "c_static/img/我的淘宝+淘气值.27f9869.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/完善资料/我的淘宝+淘气值.jpg
// module id = LnDb
// module chunks = 33